















































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class JS001 extends Vue {
    @Prop({ default: (new Date().getFullYear() - 1).toString() })
    year!: number | string;

    @Watch("year")
    yearChange(val: number | string) {
        this.form.year = val;
        this.fetchData();
    }

    statusList = ["开业/正常经营", "清算", "筹建", "停业","歇业","其他"];
    stockList = ["国有控股", "集体控股", "私人控股", "港澳台商控股", "外商控股", "其他"];

    form = {
        id: <null | number>null,
        year: this.year,
        companyName: this.$store.state.accountBook.name,
        companyCode: this.$store.state.accountBook.accountBookInfo.socialCreditCode,
        companyAddress: "",
        postalCode: "",
        companyPhone: "",
        companyEmail: "",
        businessScope: "",
        personNum: <null | number>null,
        isPersonNum: <null | number>null,
        womanNum: <null | number>null,
        isWomanNum: <null | number>null,
        businessStatus: "",
        companyHolding: "",
        isCompanyHolding: <null | number>null,
        isSure: <null | number>null,
        isWeb: <null | number>null,
        isHolding: <null | number>null,
        isScience: <null | number>null,
        isCustomsEnterprise: <null | number>null,
        isBuy: <null | number>null,
        isCard: <null | number>null,
        studentManager: <null | number>null,
        studentWorker: <null | number>null,
        soldierManager: <null | number>null,
        soldierWorker: <null | number>null,
        disablerManager: <null | number>null,
        disablerWorker: <null | number>null,
        loserManager: <null | number>null,
        loserWorker: <null | number>null,
    }
    mounted() {
        this.fetchData();
    }
    async fetchData() {
        const res = await Vue.axios.get(`gsnb/qyjbxx/get?year=${this.form.year}&accountBookId=${this.$store.state.accountBook.id}`);
        delete res.data.data.gmtCreate;
        delete res.data.data.gmtModified;
        this.form = res.data.data;

        this.$emit("update", this.form);
    }
    async save() {
        const keys = Object.keys(this.form);
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            if(this.$store.state.accountBook.accountBookInfo.province ===  "江西省") {
                // @ts-ignore
                if ((this.form[key] === null || this.form[key] === "") && key !=="isScience" && key !=="isCustomsEnterprise") {
                    this.messages()
                    break;
                }
            } else if(this.$store.state.accountBook.accountBookInfo.province ===  "辽宁省") {
                // @ts-ignore
                if ((this.form[key] === null || this.form[key] === "") && key !=="isCard") {
                    this.messages()
                    break;
                }
            }else {
                // @ts-ignore
                if ((this.form[key] === null || this.form[key] === "") && key !=="isScience" && key !=="isCustomsEnterprise" && key !=="isCard") {
                    this.messages()
                    break;
                }
            }

        }
        await Vue.axios.post(`gsnb/qyjbxx/save`, this.form);

        this.$emit("update", this.form);
    }
    messages() {
        this.$notify({
            title: "温馨提示",
            message: "请将所有信息填写完整",
            type: "warning"
        });
    }

}
